export type AvailableYMActions = 'reachGoal' | 'hit';

export interface MetricaCounterConfig {
    id: number;
    name: string;
}
